import { type FC } from 'react';
import classnames from 'classnames';

import dibsCss from 'dibs-css';

import { useServerVarsContext } from '../../../global/ServerVarsContext/ServerVarsContext.tsx';
import { PdpMobileSectionDivider } from '../../PdpMobileSectionDivider/PdpMobileSectionDivider.tsx';

const PdpSharedSellerModuleLoader: FC = () => {
    const { isMobile } = useServerVarsContext();

    const imageLoader = (
        <div
            className={classnames(
                dibsCss.roundedFull,
                dibsCss.sassyAnimateLoadingShimmer,
                dibsCss.h100px,
                dibsCss.minW100px
            )}
        />
    );

    if (isMobile) {
        return (
            <>
                <PdpMobileSectionDivider />
                <div className={dibsCss.pySmall}>
                    <div className={classnames(dibsCss.flex, dibsCss.gapSmall)}>
                        {imageLoader}
                        <div
                            className={classnames(
                                dibsCss.roundedXxsmall,
                                dibsCss.sassyAnimateLoadingShimmer,
                                dibsCss.wFull
                            )}
                            style={{ height: '150px' }}
                        />
                    </div>
                    <div
                        className={classnames(
                            dibsCss.mtMedium,
                            dibsCss.roundedXxsmall,
                            dibsCss.sassyAnimateLoadingShimmer,
                            dibsCss.wFull,
                            dibsCss.h60px
                        )}
                    />
                </div>
            </>
        );
    }

    return (
        <div
            className={classnames(
                dibsCss.flex,
                dibsCss.gapSmall,
                dibsCss.pLarge,
                dibsCss.myLarge,
                dibsCss.border,
                dibsCss.borderSolid,
                dibsCss.borderDolphin,
                dibsCss.roundedXxsmall,
                dibsCss.h200px
            )}
        >
            {imageLoader}
            <div
                className={classnames(
                    dibsCss.roundedXxsmall,
                    dibsCss.sassyAnimateLoadingShimmer,
                    dibsCss.hFull,
                    dibsCss.w300px
                )}
            />
            <div
                className={classnames(
                    dibsCss.mlAuto,
                    dibsCss.roundedXxsmall,
                    dibsCss.sassyAnimateLoadingShimmer,
                    dibsCss.h60px,
                    dibsCss.w300px
                )}
            />
        </div>
    );
};

export default PdpSharedSellerModuleLoader;
